import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const InspectionTypeContracts = () => {
  return (
    <SettingsMetaData propertyName={"Inspection_Type_Contracts"} viewPropertyName={"Inspection Type"} />
  );
};
export default InspectionTypeContracts;